// 请求验证路由拦截组件
// 未登陆的请求利用 <Navigate> 导航组件进行重定向
// 如果refresh token不存在，进行重定向处理

import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export default function RequireAuth({ children }) {
  let account_name = localStorage.getItem('account_name')   // 获取验证对象
  let refresh_token = localStorage.getItem('refresh_token') // 获取验证对象
  // console.log(1100, refresh_token);
  let location = useLocation()                              // 获取URL参数
  // 用户名与refresh token 只要有一个不存在则重定向到登录页面
  if (account_name===null || refresh_token===null) {
    // 未登入，使用Navigate组件重定向到登录页，传入state属性以保存当前URL位置信息
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return children // 验证通过，返回插槽内容，例如： ProtectedPage 页面(显示页面)
}
